import React from 'react'

const TopHeading = ({ className="text-center", head, title }) => {
    return (
        <div className={`top_heading ${className} `}>
            <p className='text-uppercase text-pink mb-1 fw-bolder'>{head}</p>
            <div className='display-6 fw-bold text-capitalize'>{title}</div>
        </div>
    )
}

export default TopHeading